var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.date)?_c('p',[_c('span',{staticClass:"help"},[_vm._v("Updated from SIS at "+_vm._s(_vm.itemDate(_vm.date))+".")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }